import { render, staticRenderFns } from "./ServiceDashboardTutorCardSkeleton.vue?vue&type=template&id=eb32b39a&"
import script from "./ServiceDashboardTutorCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./ServiceDashboardTutorCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports